var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contentDiv"},[_c('div',{staticClass:"infoDiv"},[_c('div',{staticClass:"infoValue"},[_c('span',[_vm._v(_vm._s(_vm.prefix))]),_c('span',{staticClass:"moneySpan"},[_vm._v(_vm._s(_vm.info))]),_c('span',[_vm._v(_vm._s(_vm.suffix))])]),_c('div',[_c('img',{attrs:{"src":_vm.logo,"alt":"","width":"250","height":"250"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }